import { JwtHelperService } from '@auth0/angular-jwt';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  jwtHelper = new JwtHelperService();

  constructor(
    private router: Router,
    ) {}

  setToken(token: string, refreshToken: string) {
    sessionStorage.removeItem('token')
    sessionStorage.setItem('token', token);
    sessionStorage.removeItem('refreshToken')
    sessionStorage.setItem('refreshToken', refreshToken);
    const decode = this.jwtHelper.decodeToken(token)
    sessionStorage.removeItem('permisssion')
    sessionStorage.setItem('permisssion', decode.Permissions);
    sessionStorage.removeItem('page')
    sessionStorage.setItem('page', decode.Pages);
  }

  setTokenRefresh(refreshToken: string) {
    sessionStorage.removeItem('token')
    sessionStorage.setItem('token', refreshToken);
  }

  logOut() {
    sessionStorage.clear();
    Swal.close();
    this.router.navigate(['/']);
  }

  getToken() {
    return {
      headers: new HttpHeaders({
        authorization: `Bearer ` + sessionStorage.getItem('token'),
      }),
    };
  }

  get token(): string {
    return sessionStorage.getItem('token');
  }
}
